import { Classes } from "@blueprintjs/core"
import CustomButton from "components/Atoms/CustomButton"
import CustomCard from "components/Atoms/CustomCard"
import dayjs from "dayjs"
import { useDmsTripDetailsQuery } from "generated/graphql"
import { cloneDeep, set } from "lodash-es"
import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import classNames from "utils/classNames"
import AddExtraSkuDialog from "./AddExtraSkuDialog"
import ReadyToLeaveDialog from "./ReadyToLeaveDialog"
import SkuTable from "./SkuTable"

const CheckSkus = () => {
  const { id } = useParams()
  const { data } = useDmsTripDetailsQuery({
    variables: { tripIdInt: Number(id), tripId: id },
  })

  const [showAddExtraSkuDialog, setShowAddExtraSkuDialog] = useState(false)
  const [leaveDockDialog, setLeaveDockDialog] = useState(false)

  const [state, setState] = useState<any>({
    arrivedAtDock: false,
    timestamp: new Date(),
    estimatedDespatchTime: "",
    scheduledVehicle: {},
    arrivedVehicle: {},
    supervisor: {},
    dock: {},
  })

  useEffect(() => {
    if (data) {
      const stateCopy = cloneDeep(state)
      set(
        stateCopy,
        "estimatedDespatchTime",
        data?.tripDetails?.estimatedDespatchTime
      )
      set(stateCopy, "scheduledVehicle", data?.tripDetails?.scheduledVehicle)
      set(stateCopy, "arrivedVehicle", data?.tripDetails?.vehicle)
      set(stateCopy, "dock", data?.tripDetails?.dock)
      set(stateCopy, "supervisor", data?.tripDetails?.dockSupervisor)
      set(
        stateCopy,
        "arrivedAtDock",
        data?.tripDetails?.tripLogs?.some(
          log => log?.step?.stepId === "10ac3986-cbad-425c-b0ed-0fd858b64a1a"
        )
      )
      setState(stateCopy)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return (
    <CustomCard className="p-2 border-legacy">
      <AddExtraSkuDialog
        tripId={id}
        isOpen={showAddExtraSkuDialog}
        onClose={() => setShowAddExtraSkuDialog(false)}
      />

      <ReadyToLeaveDialog
        tripId={id}
        otp={data?.tripDetails?.despatchOtp}
        isOpen={leaveDockDialog}
        onClose={() => setLeaveDockDialog(false)}
      />

      <div className="m-4">
        <div className="p-3" style={{ background: "#F5F5F5" }}>
          <div className={classNames(Classes.TEXT_LARGE)}>
            Gate pass number - {data?.tripDetails?.uuid?.split("-")[0]}
          </div>
          <div className={classNames(Classes.TEXT_SMALL, Classes.TEXT_MUTED)}>
            Driver name - {data?.tripDetails?.aggregator?.fullName}
          </div>
        </div>
      </div>

      <div className="m-4">
        <div className="p-1">
          <span>Arrived vehicle: </span>
          <span style={{ fontWeight: "bold" }}>
            {state?.arrivedVehicle?.registrationNumber}{" "}
          </span>
        </div>
        <div className="p-1">
          <span>Scheduled vehicle: </span>
          <span style={{ fontWeight: "bold" }}>
            {state?.scheduledVehicle?.registrationNumber}{" "}
          </span>
        </div>
        <div className="p-1">
          <span>Vehicle at dock: </span>
          <span style={{ fontWeight: "bold" }}>{state?.dock?.name} </span>
        </div>
        <div className="p-1">
          <span>Supervisor: </span>
          <span style={{ fontWeight: "bold" }}>
            {state?.supervisor?.fullName}{" "}
          </span>
        </div>
        <div className="p-1">
          <span>Load scheduled: </span>
          <span style={{ fontWeight: "bold" }}>
            {dayjs(new Date(state.estimatedDespatchTime)).format("h:mm a")}
          </span>
        </div>
      </div>

      <div className="m-4">
        <div
          className="grid grid-cols-12 gap-4 m-0 p-3"
          style={{ background: "#F5F5F5" }}
        >
          <div>Stock keeping units loaded</div>
          <div>
            <CustomButton
              style={{ float: "right" }}
              intent="warning"
              text="SKUs"
              icon="add"
              onClick={() => setShowAddExtraSkuDialog(true)}
            />
          </div>
        </div>
        <div className="grid grid-cols-12 gap-4 mt-6">
          <div>
            <SkuTable tripId={id} />
          </div>
        </div>
        <div className="grid grid-cols-12 gap-4">
          <div className="m-4">
            <CustomButton
              style={{ float: "right" }}
              intent="success"
              text="Ready to leave"
              onClick={() => setLeaveDockDialog(true)}
            />
          </div>
        </div>
      </div>
    </CustomCard>
  )
}

export default CheckSkus
